import { LocalStorageKeys } from "../../util/constants";

export type PosLayoutMode = "classic" | "visual" | "split";

export type PosCartViewMode = "table" | "list";

export const POS_LAYOUT_MODES: PosLayoutMode[] = ["classic", "visual", "split"];

export const isPosLayoutMode = (value: unknown): value is PosLayoutMode =>
	value === "classic" || value === "visual" || value === "split";

export const isPosCartViewMode = (value: unknown): value is PosCartViewMode =>
	value === "table" || value === "list";

export const readStoredPosLayoutMode = (): PosLayoutMode => {
	try {
		const raw = localStorage.getItem(LocalStorageKeys.POS_LAYOUT_MODE);
		if (isPosLayoutMode(raw)) return raw;
	} catch {
		// ignore
	}
	return "classic";
};

export const writeStoredPosLayoutMode = (mode: PosLayoutMode) => {
	try {
		localStorage.setItem(LocalStorageKeys.POS_LAYOUT_MODE, mode);
	} catch {
		// ignore
	}
};

/** Dispatched when POS layout is changed from TopBar (or elsewhere outside PointOfSale). */
export const POS_LAYOUT_CHANGE_EVENT = "pos:layout-change";

export const setPosLayoutMode = (mode: PosLayoutMode) => {
	writeStoredPosLayoutMode(mode);
	window.dispatchEvent(new CustomEvent(POS_LAYOUT_CHANGE_EVENT, { detail: mode }));
};

export const readStoredPosCartViewMode = (): PosCartViewMode => {
	try {
		const raw = localStorage.getItem(LocalStorageKeys.POS_CART_VIEW_MODE);
		if (isPosCartViewMode(raw)) return raw;
	} catch {
		// ignore
	}
	return "table";
};

export const writeStoredPosCartViewMode = (mode: PosCartViewMode) => {
	try {
		localStorage.setItem(LocalStorageKeys.POS_CART_VIEW_MODE, mode);
	} catch {
		// ignore
	}
};
